import { STATUS_LABELS, type UserStatus } from '../api/types';

export function StatusBadge({ status }: { status: UserStatus }) {
  return <span className={`badge badge-${status}`}>{STATUS_LABELS[status]}</span>;
}
